export enum SwarmSuccessMessages {
  ACCOUNT_SETTING_SET_ACCOUNT_CLOSURE = 'successMessageAccountClosure',
  ACCOUNT_SETTING_SET_SESSION_LIMIT = 'successSessionLimit',
  SUCCESS_MESSAGE = 'successMessage',
  DO_BET = 'betPlacedSuccess',
  OPT_IN = 'optInSuccess',
  OPT_OUT = 'optOutSuccess'
}
